// Core
import { useEffect } from "react";

// Redux
import apiSlice, { API_TAG_TYPES } from "state/api/apiSlice";
import { openNotificationPopup } from "state/application/applicationSlice";
import { removeTask } from "state/tasks/tasksSlice";

function useTaskStatusEffect(
  { isSuccess, isFetching, taskStatus, activeLoadsTasks, dispatch, TASK_TYPE },
  refetch = () => {}
) {
  useEffect(() => {
    // If the task being polled is more than 5 minutes old, remove it silently.
    if (activeLoadsTasks.length === 0) return;
    const taskActionPayload = { id: activeLoadsTasks[0].id, type: TASK_TYPE };
    const taskDateTime = new Date(activeLoadsTasks[0].started_datetime);
    const now = new Date();
    const timeout = 5 * 60 * 1000;
    if (now - taskDateTime > timeout) {
      dispatch(removeTask(taskActionPayload));
    }
    if (!isSuccess || !taskStatus) return;
    if (taskStatus.state === "SUCCESS") {
      dispatch(removeTask(taskActionPayload));
      dispatch(openNotificationPopup({ notification: taskStatus.message, type: "success" }));
      // Once the background task (e.g. a forecast/measurements upload) finishes
      // processing, force a soft refetch of every active query so the new data
      // shows without a manual page refresh — covers tables, charts and any
      // derived RTK data, regardless of which page triggered the task.
      dispatch(apiSlice.util.invalidateTags(API_TAG_TYPES));
      refetch();
    } else if (taskStatus.state === "FAILURE") {
      dispatch(removeTask(taskActionPayload));
      dispatch(openNotificationPopup({ notification: taskStatus.error, type: "error" }));
    }
  }, [isFetching]);
}

export default useTaskStatusEffect;
